<template>
  <div class="formOuter">
    <form @submit.prevent="submitForm">
      <div class="form-control" :class="{ invalid: !empId.isValid }">
        <label for="name">Employee Id</label>
        <input
          type="text"
          id="empId"
          v-model.trim="empId.val"
          @blur="clearValidity('empId')"
        />
        <span v-if="!empId.isValid">Employee Id Required</span>
      </div>
      <div class="form-control" :class="{ invalid: !name.isValid }">
        <label for="name">Employee Name</label>
        <input
          type="text"
          id="name"
          v-model.trim="name.val"
          @blur="clearValidity('name')"
        />
        <span v-if="!name.isValid">Employee Name Required</span>
      </div>
      <div class="form-control" :class="{ invalid: !designation.isValid }">
        <label for="designation">Employee designation</label>
        <input type="text"
          id="designation"
          v-model.trim="designation.val"
          @blur="clearValidity('designation')"
        />
        <span v-if="!designation.isValid">Employee designation Required</span>
      </div>
      <div class="form-control-group" :class="{ invalid: !tech.isValid }">
        <h3>Select Technologies</h3>
        <div class="form-control">
          <input
            type="checkbox"
            id="html"
            value="HTML"
            v-model="tech.val"
            @blur="clearValidity('tech')"
          />
          <label for="web">HTML</label>
        </div>
        <div class="form-control">
          <input
            type="checkbox"
            id="css"
            value="CSS"
            v-model="tech.val"
            @blur="clearValidity('tech')"
          />
          <label for="css">CSS</label>
        </div>
        <div class="form-control">
          <input
            type="checkbox"
            id="php"
            value="PHP"
            v-model="tech.val"
            @blur="clearValidity('tech')"
          />
          <label for="ios">PHP</label>
        </div>
        <div class="form-control">
          <input
            type="checkbox"
            id="jquery"
            value="jQuery"
            v-model="tech.val"
            @blur="clearValidity('tech')"
          />
          <label for="jquery">jQuery</label>
        </div>
        <div class="form-control">
          <input
            type="checkbox"
            id="javascript"
            value="Javascript"
            v-model="tech.val"
            @blur="clearValidity('tech')"
          />
          <label for="javascript">Javascript</label>
        </div>
        <div class="form-control">
          <input
            type="checkbox"
            id="angular"
            value="Angular"
            v-model="tech.val"
            @blur="clearValidity('tech')"
          />
          <label for="angular">Angular</label>
        </div>
        <div class="form-control">
          <input
            type="checkbox"
            id="vue"
            value="Vue"
            v-model="tech.val"
            @blur="clearValidity('tech')"
          />
          <label for="vue">Vue</label>
        </div>
        <span v-if="!tech.isValid">Check Atleast one Technology</span>
      </div>
      <div class="form-control" :class="{ invalid: !contact.isValid }">
        <label for="contact">Contact</label>
        <input
          type="text"
          id="contact"
          v-model="contact.val"
          @blur="clearValidity('contact')"
        />
        <span v-if="!contact.isValid">Contact Number Required</span>
      </div>
      <div class="form-control" :class="{ invalid: !personalEmail.isValid }">
        <label for="personalemail">Personal Email</label>
        <input
          type="text"
          id="personalemail"
          v-model="personalEmail.val"
          @blur="clearValidity('personalEmail')"
        />
        <span v-if="!personalEmail.isValid">Personal Email Required</span>
      </div>
      <div class="form-control" :class="{ invalid: !companyEmail.isValid }">
        <label for="companyemail">Company Email</label>
        <input
          type="text"
          id="companyemail"
          v-model="companyEmail.val"
          @blur="clearValidity('companyEmail')"
        />
        <span v-if="!companyEmail.isValid">Company Email Required</span>
      </div>
      <div class="form-control" :class="{ invalid: !address.isValid }">
        <label for="address">Address</label>
        <input
          type="text"
          id="address"
          v-model="address.val"
          @blur="clearValidity('address')"
        />
        <span v-if="!address.isValid">Address is Required</span>
      </div>
      <span v-if="!formIsValid"
        >Form Is Invalid Please fill all information again.</span
      >
      <base-button>Add Employee</base-button>
    </form>
  </div>
</template>

<script>
export default {
  props: ["empInfo"],
  data() {
    return {
      formIsValid: true,
      name: {
        val: "",
        isValid: true,
      },
      empId: {
        val: "",
        isValid: true,
      },
      designation: {
        val: "",
        isValid: true,
      },
      tech: {
        val: [],
        isValid: true,
      },
      contact: {
        val: "",
        isValid: true,
      },
      personalEmail: {
        val: "",
        isValid: true,
      },
      companyEmail: {
        val: "",
        isValid: true,
      },
      address: {
        val: "",
        isValid: true,
      },
    };
  },
  created() {
    if (this.empInfo != null) {
      this.name.val = this.empInfo.name;
      this.empId.val = this.empInfo.empId;
      this.designation.val = this.empInfo.designation;
      this.tech.val = this.empInfo.tech;
      this.contact.val = this.empInfo.contact;
      this.personalEmail.val = this.empInfo.personalEmail;
      this.companyEmail.val = this.empInfo.companyEmail;
      this.address.val = this.empInfo.address;
    }
  },
  methods: {
    validateForm() {
      this.formIsValid = true;
      if (this.name.val === "") {
        this.name.isValid = false;
        this.formIsValid = false;
      }
      if (this.empId.val === "") {
        this.empId.isValid = false;
        this.formIsValid = false;
      }
      if (this.designation.val === "") {
        this.designation.isValid = false;
        this.formIsValid = false;
      }
      if (this.contact.val === "") {
        this.contact.isValid = false;
        this.formIsValid = false;
      }
      if (this.personalEmail.val === "") {
        this.personalEmail.isValid = false;
        this.formIsValid = false;
      }
      if (this.companyEmail.val === "") {
        this.companyEmail.isValid = false;
        this.formIsValid = false;
      }
      if (this.address.val === "") {
        this.address.isValid = false;
        this.formIsValid = false;
      }
      if (this.tech.val.length === 0) {
        this.tech.isValid = false;
        this.formIsValid = false;
      }
    },
    submitForm() {
      this.validateForm();
      if (!this.formIsValid) {
        return;
      }
      const formData = {
        name: this.name.val,
        empId: this.empId.val,
        designation: this.designation.val,
        tech: this.tech.val,
        contact: this.contact.val,
        personalE: this.personalEmail.val,
        companyE: this.companyEmail.val,
        address: this.address.val,
      };
      if (this.empInfo) {
        this.$store.dispatch("employees/updateEmployee", {
          ...formData,
          id: this.empInfo.id,
        });
      }else{
        this.$store.dispatch("employees/addEmployee", formData);
      }
      this.$router.replace("/employees");
    },
    clearValidity(input) {
      this[input].isValid = true;
      this.formIsValid = true;
    },
  },
};
</script>

<style scoped>
.formOuter {
  padding: 1vw;
  box-sizing: border-box;
}
.formOuter span {
  color: red;
  margin-top: 5px;
}
.form-control {
  width: 100%;
  margin-bottom: 20px;
  text-align: left;
}
.form-control label {
  margin-bottom: 8px;
  width: 100%;
}
.form-control input[type="text"],
.form-control input[type="date"],
.form-control textarea {
  width: 100%;
  border: 1px solid #c1c1c1;
  padding: 12px;
  box-sizing: border-box;
  font-size: 14px;
}

.form-control-group {
  text-align: left;
}
.form-control-group h3 {
  text-align: left;
}
.invalid input,
.invalid textarea {
  border-color: red !important;
}
.invalid span {
  color: red;
  text-align: left;
}
.invalid h3 {
  color: red !important;
}
</style>
